import { Inject, Injectable } from '@angular/core';
import { ConfigInstanceToken, ConfigInterface } from '../interfaces/config.interface';
import { TranslateService } from '@ngx-translate/core';
import { DisplayDecorator } from '../decorators/display-decorator';
import { TimesheetNotificationModel } from '../models/low-level/timesheet-notification.model';
import { TimesheetModel } from '../models/low-level/timesheet.model';
import { TextModel } from '../models/primitive/text.model';

@Injectable({
    providedIn: 'root',
})
export class TimesheetAndExpensesUtilities {
    public constructor(
        private readonly translate: TranslateService,
        @Inject(ConfigInstanceToken) private readonly configService: ConfigInterface,
    ) {}
    /**
     * This method sorts the notifications within the timesheet based on the start time of the first entry of those notification's TR entries
     *
     * @param {TimesheetModel} timesheet
     */
    public static sortNotificationsByFirstTimesheetEntryStartTime(timesheet: TimesheetModel): void {
        timesheet.notifications.sort(
            (tsnotification1: TimesheetNotificationModel, tsnotification2: TimesheetNotificationModel) => {
                if (tsnotification1.timesheetEntries.length > 0 && tsnotification2.timesheetEntries.length > 0) {
                    const tsNotification1FirstEntry = tsnotification1.timesheetEntries[0];
                    const tsNotification2FirstEntry = tsnotification2.timesheetEntries[0];
                    const tsNotification1LastEntry =
                        tsnotification1.timesheetEntries[tsnotification1.timesheetEntries.length - 1];
                    const tsNotification2LastEntry =
                        tsnotification2.timesheetEntries[tsnotification2.timesheetEntries.length - 1];
                    if (tsNotification1FirstEntry.startDate.value.isBefore(tsNotification2FirstEntry.startDate.value)) {
                        return -1;
                    } else if (
                        tsNotification1FirstEntry.startDate.value.isSame(tsNotification2FirstEntry.startDate.value)
                    ) {
                        if (tsNotification1LastEntry.endDate.value.isBefore(tsNotification2LastEntry.endDate.value)) {
                            return -1;
                        } else if (
                            tsNotification1LastEntry.endDate.value.isSame(tsNotification2LastEntry.endDate.value)
                        ) {
                            return 0;
                        } else {
                            return 1;
                        }
                    } else {
                        return 1;
                    }
                } else {
                    return 1;
                }
            },
        );
    }

    /**
     * create the radio button options to be displayed in timesheet to select start and end address as Home/Office/Other
     */
    public getTimesheetAddressOptions(): Array<DisplayDecorator<TextModel>> {
        // build the radio button option for address
        const addressOptions: Array<DisplayDecorator<TextModel>> = [];
        addressOptions.push(
            new DisplayDecorator(
                <string>this.translate.instant('TIMESHEET_ADDRESS_OPTION_HOME'),
                new TextModel('Home', this.configService.getTimesheetAddressHome()),
            ),
        );
        addressOptions.push(
            new DisplayDecorator(
                <string>this.translate.instant('TIMESHEET_ADDRESS_OPTION_OFFICE'),
                new TextModel('Office', this.configService.getTimesheetAddressOffice()),
            ),
        );
        addressOptions.push(
            new DisplayDecorator(
                <string>this.translate.instant('TIMESHEET_ADDRESS_OPTION_OTHER'),
                new TextModel('Other'),
            ),
        );
        return addressOptions;
    }
}
